module.exports = __webpack_public_path__ + "static/img/page4.cfa1f80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doudouImg/page4.png
// module id = KXrH
// module chunks = 1